// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import { format } from "date-fns";
// import { Grid, Card, Icon } from "@mui/material";
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import MDTypography from "components/MDTypography";
// import AlertCards from "./alertCards";
// import alertData from "./alertCardData";
// import AlertSummaryTable from "./alertSummaryTable";

// function AlertList({ selectedDate }) {
//   const [summaryData, setSummaryData] = useState([]);
//   const [activeTitle, setActiveTitle] = useState("");
//   const alertCountResponse = useSelector((state) => state.alerts.alertCount?.responseData || []);

//   // const getAlertInfo = (title) => {
//   //   const match = alertCountResponse.find(
//   //     (item) => item.alertName.replace(/\s+/g, '').toLowerCase() === title.replace(/\s+/g, '').toLowerCase()
//   //   );
//   //   return { count: match ? match.alertCount : null, id: match ? match.alertID : null };
//   // };

//   const getAlertInfo = (title) => {
//   const match = alertCountResponse.find((item) => {
//     // Regex /[_\s]+/g use karein taaki "_" aur " " dono remove ho jayein
//     const backendName = item.alertName.replace(/[_\s]+/g, "").toLowerCase();
//     const frontendTitle = title.replace(/[_\s]+/g, "").toLowerCase();
//     return backendName === frontendTitle;
//   });

//   return { 
//     count: match ? match.alertCount : null, 
//     id: match ? match.alertID : null 
//   };
// };

//   const handleCardClick = async (title) => {
//     const { id } = getAlertInfo(title);
//     if (!id || !selectedDate) return;
//     setActiveTitle(title);
//     const token = localStorage.getItem("token");
//     try {
//       const res = await axios.post("https://v3.dhundhoo.com/alerts/alertSummary", 
//       { startDate: selectedDate, endDate: selectedDate, alertID: id },
//       { headers: { "x-dhundhoo-session": token }});
//       setSummaryData(res.data.responseData || []);
//     } catch (err) { console.error(err); }
//   };

//   const columns = [
//     { 
//       Header: "Time Stamp", 
//       accessor: "alertTimeStamp", 
//       Cell: ({ value }) => format(new Date(value.replace(/-/g, "/")), "MMM dd, yyyy HH:mm:ss a") 
//     },
//     { Header: "Vehicle Number", accessor: "thingID" },
//     { 
//       Header: "Location", 
//       accessor: "latitude",
//       align: "center",
//       Cell: ({ row }) => (
//         <MDBox display="flex" justifyContent="center">
//           <MDTypography 
//             component="a" 
//             href={`https://www.google.com/maps?q=${row.original.latitude},${row.original.longitude}`} 
//             target="_blank" color="info" sx={{ display: "flex", alignItems: "center", gap: 0.5, textDecoration: "underline" }}
//           >
//             <Icon>location_on</Icon>
//           </MDTypography>
//         </MDBox>
//       )
//     },
//   ];

//   return (
//     <MDBox>
//       <Grid container spacing={3} p={2}>
//         {alertData.map((alert, index) => {
//           const info = getAlertInfo(alert.title);
//           return (
//             <Grid item xs={12} md={4} xl={2} key={index}>
//               <AlertCards color={alert.color} icon={alert.icon} title={alert.title} count={info.count} onClick={() => handleCardClick(alert.title)} />
//             </Grid>
//           );
//         })}
//       </Grid>

//       {summaryData.length > 0 && (
//         <MDBox mt={4} p={2}>
//           <Card>
//             <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
//               <MDTypography variant="h6" fontWeight="medium">{activeTitle} Summary</MDTypography>
//               <MDButton color="error" variant="text" size="small" onClick={() => setSummaryData([])}>
//                 <Icon>close</Icon>&nbsp;CLEAR TABLE
//               </MDButton>
//             </MDBox>
//             <AlertSummaryTable table={{ columns, rows: summaryData }} canSearch={true} isSorted={true} entriesPerPage={{ defaultValue: 5, entries: [5, 10, 20] }} />
//           </Card>
//         </MDBox>
//       )}
//     </MDBox>
//   );
// }

// export default AlertList;

import React, { useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { format } from "date-fns";
import { Grid, Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import AlertCards from "./alertCards";
import alertData from "./alertCardData";
import AlertSummaryTable from "./alertSummaryTable";

// Sirf "Overspeed" alert allow karna hai, baaki sab alert cards hide kar denge.
// Agar backend/card title me spelling alag ho (jaise "Over Speed", "OverSpeed" waghera),
// tab bhi ye regex usko match kar lega.
const OVERSPEED_REGEX = /over\s*-?\s*speed/i;
const overspeedOnlyAlertData = alertData.filter((alert) =>
  OVERSPEED_REGEX.test(alert.title)
);

function AlertList({ selectedDate }) {
  const [summaryData, setSummaryData] = useState([]);
  const [activeTitle, setActiveTitle] = useState("");
  const alertCountResponse = useSelector((state) => state.alerts.alertCount?.responseData || []);

  // const getAlertInfo = (title) => {
  //   const match = alertCountResponse.find(
  //     (item) => item.alertName.replace(/\s+/g, '').toLowerCase() === title.replace(/\s+/g, '').toLowerCase()
  //   );
  //   return { count: match ? match.alertCount : null, id: match ? match.alertID : null };
  // };

  const getAlertInfo = (title) => {
  const match = alertCountResponse.find((item) => {
    // Regex /[_\s]+/g use karein taaki "_" aur " " dono remove ho jayein
    const backendName = item.alertName.replace(/[_\s]+/g, "").toLowerCase();
    const frontendTitle = title.replace(/[_\s]+/g, "").toLowerCase();
    return backendName === frontendTitle;
  });

  return { 
    count: match ? match.alertCount : null, 
    id: match ? match.alertID : null 
  };
};

  const handleCardClick = async (title) => {
    const { id } = getAlertInfo(title);
    if (!id || !selectedDate) return;
    setActiveTitle(title);
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post("https://v3.dhundhoo.com/alerts/alertSummary", 
      { startDate: selectedDate, endDate: selectedDate, alertID: id },
      { headers: { "x-dhundhoo-session": token }});
      setSummaryData(res.data.responseData || []);
    } catch (err) { console.error(err); }
  };

  const columns = [
    { 
      Header: "Time Stamp", 
      accessor: "alertTimeStamp", 
      Cell: ({ value }) => format(new Date(value.replace(/-/g, "/")), "MMM dd, yyyy HH:mm:ss a") 
    },
    { Header: "Vehicle Number", accessor: "thingID" },
    { 
      Header: "Location", 
      accessor: "latitude",
      align: "center",
      Cell: ({ row }) => (
        <MDBox display="flex" justifyContent="center">
          <MDTypography 
            component="a" 
            href={`https://www.google.com/maps?q=${row.original.latitude},${row.original.longitude}`} 
            target="_blank" color="info" sx={{ display: "flex", alignItems: "center", gap: 0.5, textDecoration: "underline" }}
          >
            <Icon>location_on</Icon>
          </MDTypography>
        </MDBox>
      )
    },
  ];

  return (
    <MDBox>
      <Grid container spacing={3} p={2}>
        {overspeedOnlyAlertData.map((alert, index) => {
          const info = getAlertInfo(alert.title);
          return (
            <Grid item xs={12} md={4} xl={2} key={index}>
              <AlertCards color={alert.color} icon={alert.icon} title={alert.title} count={info.count} onClick={() => handleCardClick(alert.title)} />
            </Grid>
          );
        })}
      </Grid>

      {summaryData.length > 0 && (
        <MDBox mt={4} p={2}>
          <Card>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <MDTypography variant="h6" fontWeight="medium">{activeTitle} Summary</MDTypography>
              <MDButton color="error" variant="text" size="small" onClick={() => setSummaryData([])}>
                <Icon>close</Icon>&nbsp;CLEAR TABLE
              </MDButton>
            </MDBox>
            <AlertSummaryTable table={{ columns, rows: summaryData }} canSearch={true} isSorted={true} entriesPerPage={{ defaultValue: 5, entries: [5, 10, 20] }} />
          </Card>
        </MDBox>
      )}
    </MDBox>
  );
}

export default AlertList;